export default "__VITE_ASSET__855fd319__"